import gql from 'graphql-tag';

export default gql`
  query getPublicationLogsByProjectId($projectId: Int!) {
    publication_logs(
      where: { project_id: { _eq: $projectId } }
      order_by: { published_at: desc }
      limit: 200
    ) {
      published_at
      page_id
      page_version_id
      user_id
      user {
        full_name
        email
      }
      page {
        name
      }
    }
  }
`;
